import { Injectable } from '@tanbo/vue-di-plugin'

import { ParamsClean } from '@/common/decorators/params-clean'
import { Http } from '@/services/http'

export interface RequestParams {
  /** 终端id */
  device_id: string
  page: number
  limit: number
  /** 动作 */
  action?: number
  /** 拦截方向 */
  direction?: number
  /** 结束时间 */
  end_time?: string | number
  /** 分组id */
  group_id?: string
  /** 搜索关键词 */
  key_word?: string
  /** 开始时间 */
  start_time?: string | number
  /** 策略id */
  strategy_id?: string
  date?: string[]
}

export interface IpLogRow {
  /** 终端id */
  device_id: string
  /** 计算机名 */
  computer_name: string
  /** 登记用户名 */
  user_mark: string
  /** 外网IP */
  client_ip: string
  /** 内网IP */
  system_ip: string
  /** 登录状态 */
  login_status: number
  /** 所属分组名 */
  group_name: string
  /** 系统类型,0-全部，1-windows,2-linux，3-windows server，4-mac */
  system_type: number
  /** 触发的策略名称 */
  strategy_name: string
  /** 触发的策略id */
  strategy_id: string
  /** 远程ip */
  remote_ip: string
  /** 数据流方向：未知-0，双向-1，入站-2，出站-3 */
  direction: number
  /** 动作类型：未知-0，仅记录-1，拦截/阻止-2 3-终端告警提示并记录 */
  action: number
  /** 协议类型：未知-0，任意协议-1，TCP-2 UDP-3 */
  protocol: number
  /** 本地端口 */
  local_port: string
  /** 远程端口 */
  remote_port: number
  /** 拦截时间 */
  intercept_time: number
}

export interface ResponseData {
  /** 总数 */
  total: number
  list?: IpLogRow[]
}
export interface topIpStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
  /** 排行数量（默认TOP5） */
  top_count?: number
}

export interface TopIpList {
  /** IP地址 */
  ip_address: string
  /** 拦截次数 */
  block_count: number
}

export interface topIpStatResponseData {
  /** IP拦截次数TOP列表 */
  top_ip_list: TopIpList[]
}
export interface trendStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
   /** 趋势粒度："hour"表示按小时，"day"表示按天（可选，默认"hour"） */
  granularity?: string
}



export interface trendStatResponseData {
  /** IP拦截趋势数据列表 */
  /** 时间戳列表（单位：秒，与拦截数据一一对应） */
  time_points: string[]
  /** 拦截次数列表（与时间点一一对应） */
  block_count_list: number[]
  /** 时间描述列表（如"2026-03-04 07:00"，与时间点一一对应） */
  time_desc_list: string[]
}
export interface overviewStatRequestParams {
  /** 开始时间（时间戳，单位：秒） */
  start_time: string
  /** 结束时间（时间戳，单位：秒） */
  end_time: string
}

export interface overviewStatResponseData {
  /** 今日拦截IP数量 */
  today_blocked_ip_count: number
  /** 已生效策略数量 */
  active_policy_count: number
}
@Injectable()
export class TerminalNetIpLimitListService {
  constructor(private http: Http) { }

  @ParamsClean()
  getTerminalNetIpLimitList(data: RequestParams) {
    data.action ||= null
    data.direction ||= null
    data.key_word ||= ''
    return this.http.post<ResponseData>('/terminal/net-ip-limit/list', data)
  }
  @ParamsClean([0], 1)
  getTerminalNetIpLimitExport(type: 0 | 1 = 0, data: Partial<RequestParams>, moduleName: string) {
    data.action ||= null
    data.direction ||= null
    data.key_word ||= ''
    const params = Object.assign({}, data, {
      file_type: type,
      page: 1, // 不分页
      limit: 9999999
    })
    return this.http.downloadWithBlob('/terminal/net-ip-limit/list/export', params, moduleName)
  }
  getTerminalIpaccessTopIpStat (data: topIpStatRequestParams) {
    return this.http.post<topIpStatResponseData>('/terminal/ipaccess/top-ip-stat', data)
  }
  getTerminalIpaccessTrendStat (data: trendStatRequestParams) {
    return this.http.post<trendStatResponseData>('/terminal/ipaccess/trend-stat', data)
  }
  getTerminalIpaccessOverviewStat (data: overviewStatRequestParams) {
    return this.http.post<overviewStatResponseData>('/terminal/ipaccess/overview-stat', data)
  }
}
